import type { User } from '../../collaboration/CollaborationProvider';

export const name = (user: User | null) =>
    `${user?.firstName || 'Unknown'} ${user?.lastName || 'User'}`;

export const initials = (user: User | null) =>
    `${(user?.firstName || 'U').toUpperCase().slice(0, 1)}${(user?.lastName || 'U')
        .toUpperCase()
        .slice(0, 1)}`;
